import type { FC, ImgHTMLAttributes } from 'react'

type DivingDadsLogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> & {
  readonly variant?: 'hero' | 'badge' | 'watermark'
}

const sizes: Record<NonNullable<DivingDadsLogoProps['variant']>, number> = {
  hero: 140,
  badge: 48,
  watermark: 200
}

const logoSrc = `${process.env.PUBLIC_URL}/diving-dads-logo.png`

const DivingDadsLogo: FC<DivingDadsLogoProps> = ({
  variant = 'hero',
  className = '',
  ...props
}) => {
  const decorative = variant === 'watermark'
  const height = sizes[variant]

  return (
    <img
      src={logoSrc}
      alt={decorative ? '' : 'Diving Dads at Lake Park'}
      width={Math.round(height * (733 / 659))}
      height={height}
      className={`diving-dads-logo diving-dads-logo--${variant} ${className}`.trim()}
      aria-hidden={decorative ? true : undefined}
      loading={variant === 'hero' ? 'eager' : 'lazy'}
      decoding='async'
      {...props}
    />
  )
}

export default DivingDadsLogo
